mutation DocumentTransactionBuild($input: DocumentTransactionBuildInput!) {
  documentTransactionBuild(input: $input) {
    entityDocuments {
      id
      entityId
      _documentContents
      _isAccountingDocument
      _isDocumentAmountApplied
      entityDocumentTypeId
      fileIndexInformation
      _isDocumentTypeUpdatable
      comment
      _transactionHistoryId
      documentTypeId
      documentStatusType {
        statusType
      }
      _isDocumentAmountAvailable
      currency {
        isoCode
      }
      _documentPoolName

      indexAmount
      indexCurrencyId
      indexDescription
      indexReferenceNumber
      indexTransactionDate
      _isReportingDocument

      _fileName
      _fileType
      _createdDate
      _createdByUserName
      _isDocumentShare
      fileReference
      iconType
      _fileSize
      rowSecurityId
      entityDocumentSecureRowLevels {
        name
        securityLevel
      }
      _uploadDate
      _rowTimestamp
      _isLoading
      _isDeletable
      _isUpdatable
      _isProtected
      _isSelected

      documentAppliedAmount
      paymentDocument {
        _isApprovalDocumentsRequired
      }
      invoiceDocument {
        _isApprovalDocumentsRequired
      }
      _documentType
      indexName

      _uploadedByUser
      _uploadedByUserid
      _isVerified
      _verifiedUserName
    }
  }
}
